import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {Store} from '@softline/core';
import {SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG} from "../kommissionierung.shared";
import {LlrKommissionierungStore} from "../store/kommissionierung.store";
import {Router, RouterModule} from "@angular/router";
import {
  CommandStore,
  showRequestErrors,
  SOFTLINE_FEATURE_COMMANDS,
  SOFTLINE_FEATURE_TITLE,
  TitleStore
} from "@softline/application";
import {Kommissionierung} from "../types/kommissionierung";
import {PreviousRouteService} from "../services/previous-url-service";

@Component({
    selector: 'soft-kommissionierung',
    imports: [RouterModule],
    templateUrl: './kommissionierung.component.html',
    styleUrls: ['./kommissionierung.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [PreviousRouteService]
})
export class KommissionierungComponent implements OnInit, OnDestroy {
  constructor(private store: Store,
              private router: Router,
              private previousRouteService: PreviousRouteService) {
  }

  async ngOnInit(): Promise<void> {
    this.previousRouteService.getPreviousUrl();

    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#LLR_KOMMISSIONIERUNG.TITEL_WARENZUGANG'
    );

    try {
      const result = await this.store.dispatch(
        SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG,
        LlrKommissionierungStore.actions.load
      );

      this.store.commit(
        SOFTLINE_FEATURE_COMMANDS,
        CommandStore.mutations.addSet, {
          name: KommissionierungComponent,
          commands: [
            {
              name: '#LLR_KOMMISSIONIERUNG.AKTIONEN.LABEL_WARENZUGANG',
              class: 'menu main-menu main-menu-top',
              icon: 'fa-regular fa-boxes-stacked',
              execute: async () => await this.checkKommissionierung(result),
            }
          ]
        }
      );
      await this.checkKommissionierung(result);
    }
    catch (e) {
      showRequestErrors(this.store, e);
    }
  }

  ngOnDestroy(): void {
    this.store.commit(
        SOFTLINE_FEATURE_TITLE,
        TitleStore.mutations.setTitle,
        ''
    );

    this.store.commit(
        SOFTLINE_FEATURE_COMMANDS,
        CommandStore.mutations.removeSet,
        KommissionierungComponent
    );
  }

  private async checkKommissionierung(result: Kommissionierung) {
    if (!result || Object.keys(result).length === 0) {
      await this.router.navigate(['/llr-bskomm/bestellungen']);
    } else {
      try {
        await this.router.navigate(['/llr-bskomm/artikelauswahl']);
      }
      catch (e) {
        showRequestErrors(this.store, e);
        await this.router.navigate(['/llr-bskomm']);
      }
    }
  }
}
